import React, { useEffect, useState } from "react";
import { Buffer } from "buffer";
import Img from "gatsby-image";
import submitProduct from "../../utils/submit-product";
import { Link } from "gatsby";

export const getShippingProtectionVariant = (
	productNode,
	cartSubTotal,
	hasShippingProtection,
) => {
	if (hasShippingProtection) {
		const variant = productNode?.variants.find((variant) => {
			return variant.shopifyId === hasShippingProtection.variant;
		});

		if (variant) {
			return variant;
		}
	}

	if (!productNode || !Array.isArray(productNode?.variants)) {
		return null;
	}

	let variant = productNode?.variants?.[0];
	const tenPercent = Math.floor(cartSubTotal / 10) - 1;
	variant = productNode?.variants.find((variant) => {
		return parseFloat(variant.price) >= parseFloat(tenPercent);
	});

	return variant;
};

export function cartHasShippingProtection(cart) {
	if (!cart || !cart.lineItems) {
		return null;
	}

	return cart.lineItems.find((item) => {
		return item.tags.includes("Shipping Protection");
	});
}

export function ShippingProtection(props) {
	const domain =
		process.env.GATSBY_MYSHOPIFY_URL || "tearribles.myshopify.com";

	const cartSubTotal = parseFloat(props.cart?.subtotalPrice?.amount || 0);
	const hasShippingProtection = cartHasShippingProtection(props.cart);

	const [selected, setSelected] = useState(!!hasShippingProtection);

	const product = props.data.allShopifyProduct.edges.find(({ node }) => {
		return (
			node.tags.includes("Shipping Protection") &&
			node.variants.length > 0 &&
			node.variants[0].availableForSale === true
		);
	});

	const variant = getShippingProtectionVariant(
		product?.node,
		cartSubTotal,
		hasShippingProtection,
	);

	const selectProduct = () => {
		if (!variant) {
			return;
		}

		const id = Buffer.from(variant.shopifyId, "utf-8").toString("base64");

		const values = {
			id,
			quantity: 1,
		};

		const bag = {
			props,
			setSubmitting: () => null,
			upsell: true,
		};

		return submitProduct(values, bag);
	};

	const removeProduct = () => {
		if (hasShippingProtection) {
			props.removeLineItem(hasShippingProtection);
		}
	};

	useEffect(() => {
		if (!hasShippingProtection && selected) {
			selectProduct(selected);
		}

		if (hasShippingProtection && !selected) {
			removeProduct();
		}
	}, [hasShippingProtection, selected]);

	if (domain !== "tearribles.myshopify.com") {
		return null;
	}

	if (!product || !variant) {
		return null;
	}

	const image = product.node.featuredImage.localFile.childImageSharp.fluid;

	return (
		<div className="cart__line-item shipping-protection" key={variant.id}>
			<div className="cart__line-left">
				<Img
					fluid={image}
					alt="Limited edition Tearribles"
					className="shipping-protection__image"
				/>
				<div
					className="shipping-protection__label"
					htmlFor="shipping-protection"
					key="shipping-protection-selected"
					onClick={() => setSelected(() => !selected)}
				>
					Shipping Protection
					<span className="shipping-protection__sub-info">
						Valid for U.S. shippments only
					</span>
					<span className="mobile-only">${variant.price}</span>
				</div>
			</div>
			<div className="cart__line-right">
				<span className="hide-phone">${variant.price}</span>
				<input
					className="cart__checkbox switch"
					type="checkbox"
					checked={selected}
					onChange={() => {
						setSelected((selected) => {
							return !selected;
						});
					}}
					id="shipping-protection"
					name="shipping-protection"
					value="shipping-protection"
				/>
				<label htmlFor="shipping-protection" className="switch"></label>
			</div>
		</div>
	);
}

export function ShippingProtectionInfo() {
	const domain =
		process.env.GATSBY_MYSHOPIFY_URL || "tearribles.myshopify.com";

	if (domain !== "tearribles.myshopify.com") {
		return null;
	}

	return (
		<div className="shipping-protection-info">
			<p className="shipping-protection-info__title">
				Did you add Shipping Protection?
			</p>
			<p className="shipping-protection-info__info">
				If you did, we will replace your package if it's lost, damaged,
				or stolen. Read{" "}
				<Link to={"/product/shipping-protection"}>
					important information and exclusions.
				</Link>
			</p>
		</div>
	);
}
